'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'

export default function AddBountyModal({ threadId }: { threadId: string }) {
  const [isOpen, setIsOpen] = useState(false)
  const [points, setPoints] = useState(50)
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const handleCreateBounty = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      const res = await fetch('/api/bounties', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ threadId, points: Number(points) })
      })

      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Failed to create bounty')

      setIsOpen(false)
      router.refresh()
    } catch (err: any) {
      alert(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="bg-purple-600 hover:bg-purple-500 text-white font-bold px-4 py-2 rounded-xl text-xs transition-colors shadow-lg shadow-purple-600/30 flex items-center gap-1.5"
      >
        <span>🎯</span> Attach Point Bounty
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-slate-900 border border-slate-800 rounded-[2rem] p-6 sm:p-8 max-w-md w-full shadow-2xl space-y-6">
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-bold text-white">Fund a Thread Bounty</h3>
              <button 
                onClick={() => setIsOpen(false)}
                className="text-slate-400 hover:text-white text-sm font-bold"
              >
                ✕
              </button>
            </div>

            <p className="text-xs text-slate-400 leading-relaxed">
              Allocate points from your wallet into escrow. When an engineer provides the winning solution and you mark their reply as solved, the points transfer directly to them!
            </p>

            <form onSubmit={handleCreateBounty} className="space-y-4">
              <div className="space-y-1.5">
                <label className="text-xs font-bold text-slate-400 uppercase">Bounty Amount (Points)</label>
                <input
                  type="number"
                  min="10"
                  max="10000"
                  value={points}
                  onChange={e => setPoints(Number(e.target.value))}
                  className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-sm text-white font-mono"
                  required
                />
              </div>

              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  className="bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold px-5 py-2.5 rounded-xl text-xs transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="bg-purple-600 hover:bg-purple-500 text-white font-bold px-6 py-2.5 rounded-xl text-xs transition-colors shadow-lg disabled:opacity-50"
                >
                  {loading ? 'Locking in Escrow...' : 'Confirm & Fund Bounty'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}